import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getDocs } from "firebase/firestore";
import { geohashQueryBounds } from "geofire-common";
import NoteCard from "./NoteCard";
import firebaseConfig from "../firebaseConfig";

// Initialize Firebase if not already initialized
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function LocalNotesDialog(props) {
  const { open, handleClose, currentLocation, onNotePickedUp } = props;
  const theme = useTheme();
  const [localNotes, setLocalNotes] = useState([]);

  const handleDialogClose = () => {
    handleClose(false);
  };

  const handleNotePickup = (note) => {
    // Refresh the local notes list after pickup
    fetchLocalNotes();
    // Call the callback to refresh parent components
    if (onNotePickedUp) {
      onNotePickedUp();
    }
  };

  const fetchLocalNotes = async () => {
    try {
      const db = firebase.firestore();
      const notesRef = db.collection("tokens");
      const radiusInM = 100;

      const geofireLocation = [currentLocation.lat, currentLocation.lng];
      const bounds = geohashQueryBounds(geofireLocation, radiusInM);
      const matchingDocs = [];

      for (const b of bounds) {
        const q = notesRef
          .orderBy("location.geohash")
          .startAt(b[0])
          .endAt(b[1]);

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          const noteData = doc.data();
          // Filter out expired notes
          const expiresAt = noteData.expiresAt?.toDate();
          const isExpired = expiresAt && expiresAt < new Date();

          // Only include active notes that haven't expired
          if (noteData.active !== false && !isExpired) {
            matchingDocs.push({ id: doc.id, ...noteData });
          }
        });
      }

      setLocalNotes(matchingDocs);
    } catch (error) {
      console.error("Error fetching local notes:", error);
    }
  };

  useEffect(() => {
    if (open && currentLocation) {
      fetchLocalNotes();
    }
  }, [open, currentLocation]);

  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition} sx={{ backgroundColor: theme.palette.background.default }}>
      <AppBar
        position="static"
        sx={{ backgroundColor: theme.palette.primary.main }}
      >
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleDialogClose}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontFamily: 'Gochi Hand, cursive' }}>
            Local Notes
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
        <Grid container spacing={2}>
          {localNotes.map((note) => (
            <Grid item key={note.id} xs={12} sm={6} md={4} lg={3} xl={2}>
              <NoteCard
                note={note}
                handleNotePickup={() => handleNotePickup(note)}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
export default LocalNotesDialog;
